import { FC } from 'react'
import BaseButtonGroup, {
  ButtonGroupProps as BaseButtonGroupProps,
} from 'antd/lib/button/button-group'

export interface ButtonGroupProps extends BaseButtonGroupProps {}

export const ButtonGroup: FC<ButtonGroupProps> = (props) => (
  <BaseButtonGroup {...props} />
)
